import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForArticleComponent extends Component {
  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'categoryId',
      type: 'selectRelationship',
      recordType: 'category',
      useLocaleFilter: true,
      queryParams: {
        'filter[type]': 'A_TYPE',
        'sort[name]': 'ASC',
      },
    },
  ];

  defaultColumns = [
    'id',
    'aDate',
    'artists',
    'headline',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      sortable: true,
      isMainColumn: true,
      isTruncate: true,
    },
    {
      property: 'artists',
      type: 'relation',
    },
    {
      property: 'aDate',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'categoryId',
      type: 'relation',
    },
    {
      property: 'cmsLanguageId',
      type: 'translate-value',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
